import React, { useState } from 'react';
import { CreditCard } from 'lucide-react';
import { parsePriceMXN } from '../lib/utils';
import { BACKEND_URL } from '../lib/config';

const CheckoutButton = ({ items, shipping = 0 }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCheckout = async () => {
    setLoading(true);
    setError(null);
    try {
      const checkoutItems = items.map((i) => ({
        id: i.id,
        name: i.name,
        quantity: i.qty,
        unit_price: parsePriceMXN(i.price),
      }));
      if (shipping > 0) {
        checkoutItems.push({ id: 'envio', name: 'Envío', quantity: 1, unit_price: shipping });
      }
      const res = await fetch(`${BACKEND_URL}/api/checkout/preference`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: checkoutItems }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.detail || 'Pagos en configuración, por ahora pide por WhatsApp.');
      }
      if (data.init_point) {
        // Solo se guarda la referencia del pedido: /gracias muestra lo que diga el pago
        // verificado en el servidor, no lo que haya en este navegador. La referencia sirve
        // para saber si el pago que regresa es este mismo pedido (y entonces vaciar el carrito).
        try {
          localStorage.setItem(
            'quinlate_last_order',
            JSON.stringify({ ref: data.external_reference, savedAt: Date.now() })
          );
        } catch {
          // localStorage lleno o bloqueado (modo privado, etc.) — no es crítico: el pago se
          // verifica igual, solo no se vacía el carrito solo.
        }
        window.location.href = data.init_point;
      } else {
        throw new Error('Pagos en configuración, por ahora pide por WhatsApp.');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="q-checkout">
      <button
        type="button"
        className="q-btn q-btn--gold"
        onClick={handleCheckout}
        disabled={loading || items.length === 0}
        data-testid="checkout-mp-btn"
      >
        <CreditCard size={16} strokeWidth={1.5} /> {loading ? 'Procesando…' : 'Pagar con Mercado Pago'}
      </button>
      {error && <p className="q-checkout__error" data-testid="checkout-error">{error}</p>}
    </div>
  );
};

export default CheckoutButton;
